import React from 'react';

const SystemSettings: React.FC = () => {
  return (
    <div className="p-6 max-w-7xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">System Settings</h1>
      <p>Configure system settings here.</p>
    </div>
  );
};

export default SystemSettings;
